import {AnchorProps} from '@yosmanyga/primitive-ui-spec'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {InteractFn, SpacialFn, TextFn, styled, VisualFn} from '@yosmanyga/web-style'

const Anchor = ({
    href, download,
    className,
    children
}: AnchorProps & UnnormalizedStyleProps) => {
    return <a
        href={href}
        download={download}
        className={className}
    >
        {children}
    </a>
}

const StyledAnchor = styled(Anchor)`
    ${({flow}) => SpacialFn.compileFlow(SpacialFn.normalizeFlow(flow))}
    ${({align}) => SpacialFn.compileAlign(align)}
    ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}
    ${({padding}) => SpacialFn.compilePadding(SpacialFn.normalizePadding(padding))}
    ${({width}) => SpacialFn.compileWidth(SpacialFn.normalizeWidth(width))}
    ${({position}) => SpacialFn.compilePosition(SpacialFn.normalizePosition(position))}
    ${({border}) => VisualFn.compileBorder(VisualFn.normalizeBorder(border))}
    ${({background}) => VisualFn.compileBackground(VisualFn.normalizeBackground(background))}
    ${({color}) => VisualFn.compileColor(color)}
    ${({opacity}) => VisualFn.compileOpacity(opacity)}
    ${({font}) => TextFn.compileFont(font)}
    ${({decoration}) => TextFn.compileDecoration(decoration)}
    ${({cursor}) => InteractFn.compileCursor(cursor)}
    &:hover {
        ${({pseudo}) => VisualFn.compileColor(pseudo?.hover?.color)}
        ${({pseudo}) => VisualFn.compileBackground(VisualFn.normalizeBackground(pseudo?.hover?.background))}
        ${({pseudo}) => VisualFn.compileBorder(VisualFn.normalizeBorder(pseudo?.hover?.border))}
        ${({pseudo}) => TextFn.compileDecoration(pseudo?.hover?.decoration)}
    }
`

export default StyledAnchor
